module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAeCAYAAAEgMcwxAAAAAXNSR0IArs4c6QAAAL5JREFUWAntVkEOgCAME+M3/JbP0mf5EP2HOg+EACM20gM6TghdKd0ydMc1OmQ4LWK4WJYckxqRgLPILK8gtyReWRCGXdl7t5wVrFFCYK7mVdMYr0Oa4+DitzDPRUSwCcmAwMEhH5yaFT6pNCtoxL3XXnnC6y2VhTZMJ1XxuMsi92yv3JDbfRwryXv86CFetFcVNMWIbQiW1o4REYY1B/7kgHUJdrblZ3BkH2L85gDRAesSRHNvaukSE/uQmvwnWMZatgJb0R0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu-icon.png
// module id = 70
// module chunks = 0